export interface Environment extends EnvironmentLight {
  columnSN: string;
  columnPN: string;
  columnRL: string;
  columnCustomer: string;
  columnServiceable: string;
  columnPORO: string;
  batchMandatoryItems?: BatchFormConfig;
  location: string;
  destinationEnvironments: EnvironmentLight[];
  managedByBBj: boolean;
  tiresCreationEnabled: boolean;
  userCreationEnabled: boolean;
  wheelConfiguration?: {
    displayWheel: boolean;
    wheelAssemblyReport: boolean;
  };
  addBatchDocumentEnabled: boolean;
  toStoreFeature: boolean;
  storageStrategy: StorageStrategyType;
}

export enum StorageStrategyType {
  NO_STORAGE = 'NO_STORAGE',
  AGT = 'AGT',
  ZB = 'ZB'
}

export interface EnvironmentLight {
  id: number;
  name: string;
}

interface BatchFormConfig {
  customer: boolean;
  transporter: boolean;
  container: boolean;
  cmrQuantity: boolean;
  licensePlate: boolean;
  remark: boolean;
}
